import { useMutation } from '@tanstack/react-query';
import BackendClient from '@/api/backendClient.ts';
import { BackendSuccessResponse } from '@/types/response/Api/BackendSuccessResponse';
import { BackendErrorResponse } from '@/types/response/Api/BackendErrorResponse';
import { transformBackendErrors } from '@/utils/transformBackendErrors.ts';
import dayjs from 'dayjs';

const useExportUserData = () => {
  const mutationFn = async () => {
    return exportData();
  };

  return useMutation({
    mutationFn,
  });
};

export default useExportUserData;

async function exportData(): Promise<Record<string, any>> {
  try {
    const response = await BackendClient.get<BackendSuccessResponse<Record<string, any>>>('/api/auth/export');
    const data = response.data.data;

    // Convert JSON to string and create a blob
    const jsonBlob = new Blob([JSON.stringify(data, null, 2)], {
      type: 'application/json',
    });

    // Trigger download
    const url = URL.createObjectURL(jsonBlob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `brandsnag_data_export_${dayjs().local().format('YYYY_MM_DD_HH_mm')}.json`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);

    return data;
  } catch (error: any) {
    if (error.response && error.response.data) {
      const errorResponse = error.response.data as BackendErrorResponse;

      throw new Error(transformBackendErrors(errorResponse).join(', '));
    }

    throw new Error(error.message ?? 'An error occurred while exporting user data.');
  }
}
